import { generateApiUrl, performApiRequest } from '@/infrastructure/api-requests';
import { GeneralPartner } from './types';

export function getGeneralPartner(): Promise<GeneralPartner> {
  const url = generateApiUrl('/api/unauthorized/general-partner/get-general-partner-by-host');
  return performApiRequest<GeneralPartner>({ url, method: 'GET' });
}
